const situationRoutes = <T extends string>(baseRoute: T) => {
  const SITUATION = `${baseRoute}`;
  return {
    route: `${SITUATION}`,
    VERTI_CLIENT: {
      route: `${baseRoute}`,
    },
    FAMILY_SITUATION: {
      route: `${baseRoute}/1-2-situation`,
    },
    INSURANCE_START_DATE: {
      route: `${baseRoute}/1-3-versicherungsbeginn`,
    },
  } as const;
};

const offerRoutes = <T extends string>(baseRoute: T) => {
  const OFFER = `${baseRoute}/2-angebot`;
  return {
    route: `${OFFER}`,
  } as const;
};

const contractRoutes = <T extends string>(baseRoute: T) => {
  const CONTRACT = `${baseRoute}/3-vertrag`;
  return {
    route: `${CONTRACT}`,
    POLICYHOLDER_DATA: {
      route: `${CONTRACT}/3-1-name`,
    },
    POLICYHOLDER_CONTACT: {
      route: `${CONTRACT}/3-2-kontakt`,
    },
    POLICYHOLDER_ADDRESS: {
      route: `${CONTRACT}/3-3-adresse`,
    },
    TAX_DEDUCTION_PROFESSION: {
      route: `${CONTRACT}/3-4-beruf`,
    },
    PARTNER_DATA: {
      route: `${CONTRACT}/3-5-partner`,
    },
    PREVIOUS_INSURANCE: {
      route: `${CONTRACT}/3-6-vorversicherung`,
    },
    PAYMENT: {
      route: `${CONTRACT}/3-7-konto`,
    },
    SEPA: {
      route: `${CONTRACT}/3-8-sepa`,
    },
    ERROR_CLIENT: {
      route: `${CONTRACT}/kunden-fehler`,
    },
    BAD_CLIENT: {
      route: 'unbekannter-fehler',
    },
  } as const;
};

const summaryRoutes = <T extends string>(baseRoute: T) => {
  const SUMMARY = `${baseRoute}/4-zusammenfassung`;
  return {
    route: `${SUMMARY}`,
    CONFIRMATION: {
      route: `${SUMMARY}`,
    },
    OK: {
      route: `${SUMMARY}/4-2-OK`,
    },
    KO: {
      route: `${SUMMARY}/fehler`,
    },
  } as const;
};

const thankYouRoutes = <T extends string>(baseRoute: T) => {
  const THANK_YOU = `${baseRoute}/5-danke`;
  return {
    route: `${THANK_YOU}`,
    EXISTING_CONTRACT_ERROR: {
      route: 'vorhandener-vertragsfehler',
    },
  } as const;
};

export enum Flow {
  NEW_QUOTATION = 'NEW_QUOTATION',
}

export enum BasePath {
  NEW_QUOTATION = 'rechner',
}

const projectRoutes = <T extends string>(baseRoute: T) =>
  ({
    route: baseRoute,
    SITUATION: situationRoutes(baseRoute),
    OFFER: offerRoutes(baseRoute),
    CONTRACT: contractRoutes(baseRoute),
    SUMMARY: summaryRoutes(baseRoute),
    THANK_YOU: thankYouRoutes(baseRoute),
  }) as const;

export const RoutePaths = {
  EMPTY: {
    route: '',
  },
  WILDCARD: {
    route: '**',
  },
  COMPONENTS_PREVIEW: {
    route: 'components-preview',
  },
  GENERIC_ERROR: {
    route: 'fehler',
  },
  MAINTENANCE_PAGE: {
    route: 'wartungsseite',
  },
  [Flow.NEW_QUOTATION]: projectRoutes(BasePath.NEW_QUOTATION),
} as const;
